/* Pulley Puzzle level builder. A random hole-free block shape; its outline is one closed belt loop.
   Tiles sit on the outline's corners and straights. Bits: N=1 E=2 S=4 W=8. */
(function (g) {
  function build(k) {
    for (var attempt = 0; attempt < 200; attempt++) {
      var P = {}, cells = 0, target = Math.round(k * k * (0.45 + Math.random() * 0.2));
      function has(x, y) { return !!P[x + ',' + y]; }
      function ok() {
        for (var vx = 0; vx <= k; vx++) for (var vy = 0; vy <= k; vy++) {
          var a = has(vx - 1, vy - 1), b = has(vx, vy - 1), c = has(vx - 1, vy), d = has(vx, vy);
          if ((a && d && !b && !c) || (b && c && !a && !d)) return false; // pinch point
        }
        var seen = {}, st = [[-1, -1]], n = 0;                            // flood the outside
        while (st.length) {
          var p = st.pop(), key = p[0] + ',' + p[1];
          if (seen[key] || p[0] < -1 || p[1] < -1 || p[0] > k || p[1] > k || has(p[0], p[1])) continue;
          seen[key] = 1; n++;
          st.push([p[0] + 1, p[1]], [p[0] - 1, p[1]], [p[0], p[1] + 1], [p[0], p[1] - 1]);
        }
        return n + cells === (k + 2) * (k + 2);                            // no holes
      }
      var sx = Math.floor(Math.random() * k), sy = Math.floor(Math.random() * k);
      P[sx + ',' + sy] = 1; cells = 1;
      for (var t = 0; t < 4000 && cells < target; t++) {
        var keys = Object.keys(P), base = keys[Math.floor(Math.random() * keys.length)].split(',').map(Number);
        var dir = [[1, 0], [-1, 0], [0, 1], [0, -1]][Math.floor(Math.random() * 4)];
        var nx = base[0] + dir[0], ny = base[1] + dir[1];
        if (nx < 0 || ny < 0 || nx >= k || ny >= k || has(nx, ny)) continue;
        P[nx + ',' + ny] = 1; cells++;
        if (!ok()) { delete P[nx + ',' + ny]; cells--; }
      }
      if (cells < Math.max(3, target - 2)) continue;
      var n = k + 1, tiles = new Array(n * n).fill(0);
      function edge(x1, y1, x2, y2) {           // vertices (x,y), x = column
        var a = y1 * n + x1, b = y2 * n + x2;
        if (x2 > x1) { tiles[a] |= 2; tiles[b] |= 8; }
        else if (y2 > y1) { tiles[a] |= 4; tiles[b] |= 1; }
      }
      Object.keys(P).forEach(function (key) {
        var c = key.split(',').map(Number), x = c[0], y = c[1];
        if (!has(x, y - 1)) edge(x, y, x + 1, y);
        if (!has(x, y + 1)) edge(x, y + 1, x + 1, y + 1);
        if (!has(x - 1, y)) edge(x, y, x, y + 1);
        if (!has(x + 1, y)) edge(x + 1, y, x + 1, y + 1);
      });
      var corners = tiles.filter(function (v) { return v && v !== 5 && v !== 10; }).length;
      if (corners < 4 + Math.min(6, k)) continue;   // want some turns to solve
      return { n: n, solution: tiles };
    }
    return null;
  }
  function rot(v, r) { r = ((r % 4) + 4) % 4; for (var i = 0; i < r; i++) v = ((v << 1) | (v >> 3)) & 15; return v; }
  function solved(n, cur) {
    var on = 0, start = -1;
    for (var i = 0; i < cur.length; i++) {
      var v = cur[i]; if (!v) continue; on++; if (start < 0) start = i;
      var x = i % n, y = Math.floor(i / n);
      if (v & 1 && !(y > 0 && cur[i - n] & 4)) return false;
      if (v & 4 && !(y < n - 1 && cur[i + n] & 1)) return false;
      if (v & 2 && !(x < n - 1 && cur[i + 1] & 8)) return false;
      if (v & 8 && !(x > 0 && cur[i - 1] & 2)) return false;
    }
    var seen = {}, st = [start], cnt = 0;          // one loop, not several
    while (st.length) {
      var j = st.pop(); if (seen[j]) continue; seen[j] = 1; cnt++;
      var w = cur[j];
      if (w & 1) st.push(j - n); if (w & 4) st.push(j + n); if (w & 2) st.push(j + 1); if (w & 8) st.push(j - 1);
    }
    return cnt === on;
  }
  g.PulleyGen = { build: build, rot: rot, solved: solved };
})(typeof window !== 'undefined' ? window : globalThis);
